// import ztree from './ztree.vue'
// ztree.install = function (Vue) {
//   Vue.component(ztree.name, ztree);
// };
import tree from "vue-giant-tree"
export default tree



// WEBPACK FOOTER //
// ./src/ni-ui/tree/index.js